import Vue from 'vue'
import { Client } from '../client'
import store from '@/modules/store'
import BasicCalls from '@/api/models/BasicCalls'

class Notifications extends BasicCalls {
    constructor(supportedPush) {
        super()
        this.apiRoot = 'frontend-api'
        this.apiVersion = ''
        this.apiBase = 'notification'
        this._client = new Client()
        this._supportedPush = supportedPush
        this._notificationsAllowed = this._client.dataStorage.notificationsAllowed
    }

    /**
     *  Notifications handling
     */

    allowNotifications() {
        const notificationTypes = store.getters['site/config']?.push_notifications
        if (notificationTypes) this._client.dataStorage.notificationTypes = notificationTypes
        this.notificationsAllowed = true
    }
    forbidNotifications() {
        this._client.dataStorage.notificationTypes = undefined
        this.notificationsAllowed = false
    }

    closeForNow() {
        this.notificationsAllowed = false
        this._client.dataStorage.setNotificationsIgnoreFor2Week()
    }

    get isIgnoredByTime() {
        return this._client.dataStorage.notificationsIsIgnoreByTime
    }

    get supportedPush() {
        return this._supportedPush
    }

    get notificationsAllowed() {
        return !!this._notificationsAllowed
    }

    set notificationsAllowed(val) {
        this._notificationsAllowed = val
        this._client.dataStorage.notificationsAllowed = val
    }

    get isDecided() {
        return this._notificationsAllowed !== null
    }

    /**
     *  Unregister to notifications
     */

    unregister() {
        return new Promise((resolve, reject) => {
            if (this.notificationsAllowed) {
                if (this.supportedPush) {
                    Vue.prototype
                        .$deleteToken(Vue.prototype.$messaging)
                        .then((res) => {
                            this.forbidNotifications()
                            resolve(res)
                        })
                        .catch((e) => {
                            reject(e)
                        })
                } else {
                    this.forbidNotifications()
                    resolve()
                }
            } else {
                resolve({ not_registered: true })
            }
        })
    }

    /**
     *  Register to notifications
     */
    register() {
        return new Promise((resolve, reject) => {
            try {
                if (this.supportedPush) {
                    Notification.requestPermission()
                        .then((res) => {
                            if (res === 'denied') {
                                const msg = this.requestDenied(
                                    'alerts.notifications.request_title',
                                    'alerts.notifications.request_text'
                                )
                                reject(`[${msg.title}], ${msg.text}`)
                                return
                            }
                            Vue.prototype
                                .$getToken(Vue.prototype.$messaging, {
                                    vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY,
                                })
                                .then((currentToken) => {
                                    if (currentToken) {
                                        window.debug.info(`Register notification: ${currentToken}`)
                                        this.store('register', {
                                            deviceToken: currentToken,
                                        })
                                            .then((res) => {
                                                this.allowNotifications()
                                                resolve(res.success)
                                            })
                                            .catch((err) => {
                                                const msg = this.requestDenied('alerts.error', err)
                                                reject(`[${msg.title}], ${msg.text}`)
                                            })
                                    } else {
                                        const msg = this.requestDenied(
                                            'alerts.error',
                                            'alerts.notifications.no_token'
                                        )
                                        reject(`[${msg.title}], ${msg.text}`)
                                    }
                                })
                                .catch((err) => {
                                    const msg = this.requestDenied(
                                        'alerts.notifications.token_title',
                                        'alerts.notifications.token_text'
                                    )
                                    reject(`[${msg.title}], ${err}`)
                                })
                        })
                        .catch((err) => {
                            const msg = this.requestDenied(
                                'alerts.notifications.request_title',
                                'alerts.notifications.request_text'
                            )

                            reject(`[${msg.title}], ${err}`)
                        })
                } else {
                    this.allowNotifications()
                    resolve()
                }
            } catch (e) {
                reject(e)
            }
        })
    }
    requestDenied(title, text) {
        let translatedTitle = Vue.i18n.translate(title)
        let translatedText = Vue.i18n.translate(text)
        store.dispatch('toastWarning', {
            title: translatedTitle,
            text: translatedText,
        })
        this._client.dataStorage.notificationTypes = undefined
        return { title: translatedTitle, text: translatedText }
    }
}

export { Notifications }
